import 'regenerator-runtime/runtime';
import { vsosHttp as http } from 'lib/services/http';

const getAssignedLicenses = (profileId = '') => {
  return http.get('licenses/features', {
    params: {
      profileId,
    },
  });
};

export default {
  getAssignedLicenses,
};
